import moment from 'moment';
import { Model } from '../Model.js';
import { Interval } from '../Interval/Interval.js';

var _dec, _class;

/**
 * Plain object ShipmentCollection representation.
 *
 */

/**
 * Serialized object ShipmentCollection representation.
 *
 */

/**
 * Plain object Packlink's API response representation.
 *
 */

/**
 * Plain object Packlink's API POST payload representation.
 *
 */

let ShipmentCollection = (_dec = Model(), _dec(_class = class ShipmentCollection {
  /**
   * Takes a IShipmentCollectionApiResponse from Packlink's API and returns a ShipmentCollection.
   *
   * @param response  IShipmentCollectionApiResponse response from Packlink's API.
   *
   */
  static createFromResponse(response) {
    return new ShipmentCollection(response.collection_date ? moment(response.collection_date, 'YYYY/MM/DD').hour(12) : undefined, response.collection_time ? Interval.createFromResponse(`[${response.collection_time.replace('-', ' , ')}]`) : undefined);
  }

  /**
   * Takes a serialized ShipmentCollection and returns a ShipmentCollection.
   *
   * It allows you to hint the type of data via type params.
   *
   * @typeparam U  Type of the deserialized ShipmentCollection.
   * This allows apps using the SDK to provide their own serialization and deserialization types.
   * By default equals to SerializedShipmentCollection.
   * @typeparam P  Type of the serialized data. By default equals to `U`.
   *
   * @param data  Serialized representation of ShipmentCollection.
   *
   */

  /**
   * Takes a serialized ShipmentCollection and returns a ShipmentCollection.
   *
   * It allows you to hint the type of data via type params.
   *
   * @typeparam U  Type of the deserialized ShipmentCollection.
   * This allows apps using the SDK to provide their own serialization and deserialization types.
   * By default equals to SerializedShipmentCollection.
   * @typeparam P  Type of the serialized data. By default equals to `U`.
   *
   * @param data  Serialized representation of ShipmentCollection.
   *
   */

  /**
   * Takes a serialized ShipmentCollection and returns a ShipmentCollection.
   *
   * It allows you to hint the type of data via type params.
   *
   * @typeparam U  Type of the deserialized ShipmentCollection.
   * This allows apps using the SDK to provide their own serialization and deserialization types.
   * By default equals to SerializedShipmentCollection.
   * @typeparam P  Type of the serialized data. By default equals to `U`.
   *
   * @param data  Serialized representation of ShipmentCollection.
   *
   */

  /**
   * Takes a serialized ShipmentCollection and returns a ShipmentCollection.
   *
   * It allows you to hint the type of data via type params.
   *
   * @typeparam U  Type of the deserialized ShipmentCollection.
   * This allows apps using the SDK to provide their own serialization and deserialization types.
   * By default equals to SerializedShipmentCollection.
   * @typeparam P  Type of the serialized data. By default equals to `U`.
   *
   * @param data  Serialized representation of ShipmentCollection.
   *
   */
  static deserialize(data) {
    if (!data) {
      return;
    }
    return new ShipmentCollection(data.date ? moment(data.date, 'YYYY/MM/DD').hour(12) : undefined, Interval.deserialize(data.interval));
  }

  /**
   * Returns a new ShipmentCollection. Typings of the properties depend on the class type param T
   *
   */
  constructor(date, interval) {
    this.date = date;
    this.interval = interval;
  }

  /**
   * Returns a JSON serialized version of the ShipmentCollection.
   *
   */
  toJSON() {
    var _this$date, _this$interval;
    return {
      date: (_this$date = this.date) === null || _this$date === void 0 ? void 0 : _this$date.toISOString(),
      interval: (_this$interval = this.interval) === null || _this$interval === void 0 ? void 0 : _this$interval.toJSON()
    };
  }

  /**
   * Returns a clone of the ShipmentCollection.
   *
   */
  clone() {
    var _this$date2, _this$interval2;
    return new ShipmentCollection((_this$date2 = this.date) === null || _this$date2 === void 0 ? void 0 : _this$date2.clone(), (_this$interval2 = this.interval) === null || _this$interval2 === void 0 ? void 0 : _this$interval2.clone());
  }

  /**
   * Returns whether the two ShipmentCollection are equal.
   *
   */
  equals(shipmentCollection) {
    var _this$date3, _shipmentCollection$d, _this$interval3;
    if (!shipmentCollection) {
      return false;
    }
    return ((_this$date3 = this.date) === null || _this$date3 === void 0 ? void 0 : _this$date3.toISOString()) === ((_shipmentCollection$d = shipmentCollection.date) === null || _shipmentCollection$d === void 0 ? void 0 : _shipmentCollection$d.toISOString()) && (this.interval === undefined && shipmentCollection.interval === undefined ? true : !!((_this$interval3 = this.interval) !== null && _this$interval3 !== void 0 && _this$interval3.equals(shipmentCollection.interval)));
  }

  /**
   * Returns a JSON with the payload necessary to create a ShipmentCollection.
   *
   */
  getCreatePayload() {
    return {
      collection_date: this.date ? this.date.format('YYYY/MM/DD') : undefined,
      collection_time: this.interval ? this.interval.getTimeStrip() : undefined
    };
  }
}) || _class);

export { ShipmentCollection };
//# sourceMappingURL=ShipmentCollection.js.map
